/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserByEmailResponse
 */
export interface UserByEmailResponse {
    /**
     * True iff a user row matches the email (case-insensitive).
     * @type {boolean}
     * @memberof UserByEmailResponse
     */
    found: boolean;
    /**
     * The matched user's id. Null when found=false.
     * @type {string}
     * @memberof UserByEmailResponse
     */
    userId?: string | null;
}

/**
 * Check if a given object implements the UserByEmailResponse interface.
 */
export function instanceOfUserByEmailResponse(value: object): value is UserByEmailResponse {
    if (!('found' in value) || value['found'] === undefined) return false;
    return true;
}

export function UserByEmailResponseFromJSON(json: any): UserByEmailResponse {
    return UserByEmailResponseFromJSONTyped(json, false);
}

export function UserByEmailResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserByEmailResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'found': json['found'],
        'userId': json['user_id'] == null ? undefined : json['user_id'],
    };
}

export function UserByEmailResponseToJSON(json: any): UserByEmailResponse {
    return UserByEmailResponseToJSONTyped(json, false);
}

export function UserByEmailResponseToJSONTyped(value?: UserByEmailResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'found': value['found'],
        'user_id': value['userId'],
    };
}

